// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Close from "@guestsupply/XDL/Icons/Close";
import ErrorAlert from "@guestsupply/XDL/Icons/ErrorAlert";
import InfoAlert from "@guestsupply/XDL/Icons/InfoAlert";
import SuccessAlert from "@guestsupply/XDL/Icons/SuccessAlert";
import WarningAlert from "@guestsupply/XDL/Icons/WarningAlert";
import { buttonTransparent } from "@guestsupply/XDL/PreStyle/button";
import { xBaseTheme } from "@guestsupply/XDL/types";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import ToastPropsDefault, { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...ToastPropsDefault,
        closeButtonProps: {
            mergeCss: true,
            color: "transparent",
            buttonType: "solid",
            shape: "pill",
            css: css`
                padding: 0;
                ${buttonTransparent}
                ${IconWrapper} {
                    color: ${color("text.main")};
                    &:hover {
                        color: ${color("text.main", 0.33)}!important;
                    }
                }
                &:hover:not(:disabled) {
                    ${IconWrapper} {
                        color: ${color("text.main", 0.33)}!important;
                    }
                }
            `,
            size: 24,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: Close,
            size: 10,
            color: "text.main",
            css: css`
                &:hover {
                    color: ${color("text.main", 0.33)} !important;
                }
            `,
        },
        iconProps: {
            mergeCss: true,
            size: 20,
            css: css`
                margin-top: 2px;
                margin-right: 12px;
            `,
        },
        iconSrcByMessage: {
            success: SuccessAlert,
            warning: WarningAlert,
            danger: ErrorAlert,
            info: InfoAlert,
        },
        bodyTypographyProps: {
            mergeCss: true,
            css: css`
                &,
                p {
                    font-size: 13px;
                    font-weight: 400;
                    letter-spacing: 0;
                    line-height: 20px;
                    margin: 0;
                }
            `,
            color: "text.main",
        },
        cssOverrides: {
            toast: css`
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                border-style: solid;
                border-width: 1px;
                border-radius: 2px;
                padding: 14px;
                background: ${({ messageType }: any) => color(`${messageType}.light`)};
                @media print {
                    display: none;
                }
                ${xScreen("lte", "xs")} {
                    max-width: calc(100% - 30px);
                    margin: 0 15px;
                }
            `,
            toastBody: css`
                &&& {
                    margin: 0;
                }
                align-items: flex-start;
            `,
        },
    },
    toasterProps: {
        ...toasterPropsDefault,
    },
} as xBaseTheme["toast"];
